<div class="contents-area">
  <div class="element-column">

    <!-- 検索コントロール -->
    <div class="block-row">
      <!-- 1列目 -->
      <div class="column-list">
        <label class="list-input-title">受注企画回</label>
        <div class="list-input-content">
          <input
            type="text"
            id="tbx_OrderReceptionCatalog"
            [(ngModel)]="model.orderReceptionCatalog"
            class="deliv-catalog"
            [tabindex]="0"
            forcedEnabledMode=""
            plessInputTextSub
            [restrict]="'[0-9]'"
            [maxlength]="8"
          />
        </div>

        <label class="list-input-title">部門</label>
        <app-class-code-combo-box
          class="list-input-content"
          id="cmb_ClassCodeList"
          #cmb_ClassCodeList
          [subid]="'cmb_ClassCodeList'"
          [(ngModel)]="model.classCode"
          [forcedEnabledMode]="'true'"
          [tabindex]="0"
          [style.width.rem]="15"
        >
        </app-class-code-combo-box>

        <label class="list-input-title">Ｐコード</label>
        <div class="list-input-content">
          <input
            type="text"
            id="tbx_PCode"
            [(ngModel)]="model.pCode"
            class="pcode"
            [tabindex]="0"
            forcedEnabledMode=""
            plessInputTextSub
            [restrict]="'[P0-9]'"
            [maxlength]="8"
          />
        </div>
      </div>

      <!-- 2列目 -->
      <div class="column-list">
        <label class="list-input-title">配達企画回</label>
        <div class="list-input-content">
          <input
            type="text"
            id="tbx_MediumName"
            [(ngModel)]="model.deliveryCatalog"
            class="deliv-catalog"
            [tabindex]="0"
            forcedEnabledMode=""
            plessInputTextSub
            [restrict]="'[0-9]'"
            [maxlength]="8"
          />
        </div>

        <label class="list-input-title">バイヤーコード</label>
        <app-code-combo-box
          class="list-input-content"
          id="cmb_CodeList"
          #cmb_CodeList
          [subid]="'cmb_CodeList'"
          [codeDiv]="'ct357'"
          [labelField]="'codeValueName'"
          [(ngModel)]="model.buyerCode"
          [autofocus]="true"
          [forcedEnabledMode]="'true'"
          [tabindex]="0"
        >
        </app-code-combo-box>

        <label class="list-input-title">商品名</label>
        <div class="list-input-content">
          <input
            type="text"
            id="tbx_GuideGoodsName"
            [(ngModel)]="model.guideGoodsName"
            [style.width.rem]="32"
            [tabindex]="0"
            forcedEnabledMode=""
            plessInputTextSub
            [maxlength]="30"
            [restrict]="'[ -￮]'" 
          />
        </div>
      </div>

      <!-- 3列目 -->
      <div class="column-list">
        <label class="list-input-title">注文コード</label>
        <div class="list-input-content">
          <input
            type="text"
            id="tbx_Feature"
            [(ngModel)]="model.orderNum"
            [style.width.rem]="6"
            [tabindex]="0"
            forcedEnabledMode=""
            plessInputTextSub
            [restrict]="'[0-9]'"
            [maxlength]="6"
          />
        </div>

        <label class="list-input-title">アイテムコード</label>
        <div class="list-input-content">
          <input
            type="text"
            id="tbx_ItemCode"
            [(ngModel)]="model.itemCode"
            [style.width.rem]="6"
            [tabindex]="0"
            forcedEnabledMode=""
            plessInputTextSub
            [restrict]="'[0-9]'"
            [maxlength]="7"
          />
        </div>

        <label class="list-input-title">規格名</label>
        <div class="list-input-content">
          <input
            type="text"
            id="tbx_GuideStandardName"
            [(ngModel)]="model.guideStandardName"
            [style.width.rem]="17"
            [tabindex]="0"
            forcedEnabledMode=""
            plessInputTextSub
            [maxlength]="15"
            [restrict]="'[ -￮]'" 
          />
        </div>
      </div>
    </div>

    <!-- グリッドテーブル -->
    <div>
      <button
        id="btn_SearchGoods"
        class="btn-secondary"
        [tabindex]="0"
        (click)="eventSearchButton_CLICKHandler()"
        forcedEnabledMode="'true'"
      >
        検索
      </button>
      <div class="action-area">
        <app-pager
          [prevDisabled]="(model.currentPageNo <= 1)"
          [nextDisabled]="(model.currentPageNo >= model.endPageNo)"
          [totalNum]="model.totalNum"
          [startNum]="model.startDispNum"
          [endNum]="model.endDispNum"
          (prevHandler)="eventPrevPageButton_CLICKHandler()"
          (nextHandler)="eventNextPageButton_CLICKHandler()">
        </app-pager>
      </div>

      <div class="table-test">
        <!-- データグリッド定義 提案候補商品一覧" -->
        <wj-flex-grid
          #dtg_RememberGoodsList
          id="dtg_RememberGoodsList"
          [itemsSource]="model.viewRememberGoodsList"
          [tabindex]="0"
          [selectionMode]="'Row'"
          [headersVisibility]="'Column'"
          [isReadOnly]="false"
          [allowDragging]="'None'"
          [allowSorting]="false"
        >
          <wj-flex-grid-column [minWidth]="5"  [width]="40" [isReadOnly]="true" [header]="' '" [binding]="'check'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <input type="checkbox" [(ngModel)]="cell.item.check" [tabindex]="-1" (click)="$event.stopPropagation()" />
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="80" [isReadOnly]="true" [header]="'ステータス'" [binding]="'rememberGoodsStatusName'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="100" [isReadOnly]="true" [header]="'注文コード'" [binding]="'orderNum'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="170" [isReadOnly]="true" [header]="'部門'" [binding]="'classCode'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              {{cell.item.classCode}}:{{cell.item.className}}
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="240" [isReadOnly]="true" [header]="'バイヤーコード'" [binding]="'buyerCode'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              {{cell.item.buyerCode}}:{{cell.item.buyerName}}
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="100" [isReadOnly]="true" [header]="'アイテムコード'" [binding]="'itemCode'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="100" [isReadOnly]="true" [header]="'Ｐコード'" [binding]="'pCode'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="240" [isReadOnly]="true" [header]="'商品名'" [binding]="'guideGoodsName'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="240" [isReadOnly]="true" [header]="'規格名'" [binding]="'guideStandardName'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="150" [isReadOnly]="true" [header]="'受注受付開始企画回'" [binding]="'orderReceptionStartCatalog'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="150" [isReadOnly]="true" [header]="'受注受付終了企画回'" [binding]="'orderReceptionEndCatalog'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="120" [isReadOnly]="true" [header]="'配達開始企画回'" [binding]="'deliveryStartCatalog'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="120" [isReadOnly]="true" [header]="'配達終了企画回'" [binding]="'deliveryEndCatalog'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="120" [isReadOnly]="true" [header]="'配達サイクル区分'" [binding]="'deliveryCycleDivName'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="120" [isReadOnly]="true" [header]="'商品マスタ単価'" [binding]="'goodsPrice'" [align]="'right'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="80" [isReadOnly]="true" [header]="'値引単価'" [binding]="'discountUnitPrice'" [align]="'right'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [width]="60" [isReadOnly]="true" [header]="'値引率'" [binding]="'discountRate'" [align]="'right'"></wj-flex-grid-column>
        </wj-flex-grid>
      </div>
    </div>

  </div>
</div>

<footer class="footer-buttons">
  <button
    id="btn_add"
    class='btn-secondary'
    [tabindex]="0"
    (click)="eventAddButton_CLICKHandler()"
  >
    新規追加
  </button>
  <button
    id="btn_delete"
    class='btn-tartiary warning'
    [tabindex]="0"
    (click)="eventDeleteButton_CLICKHandler()"
  >
    削除
  </button>
  <button
    id="btn_outputList"
    class='btn-secondary'
    [tabindex]="0"
    forcedEnabledMode="true"
    (click)="eventOutputListButton_CLICKHandler()"
  >
    リスト出力
  </button>
  <button
    id="btn_confirm"
    class='btn-primary'
    [tabindex]="0"
    (click)="eventConfirmButton_CLICKHandler()"
  >
    情報確定
  </button>
</footer>